import React from 'react';
import 'twin.macro';

export const TableHead = ({ children }) => <thead>{children}</thead>;
